define(['text!./templates/basler-referrer-dialog.html'], (dialogTemplate) => {

        const directive = (ModalService, BaslerReferrerService, $q, $translate, ViewModelService) => { // NOSONAR

            return {
                restrict: 'A',
                scope: {
                    submission: '=',
                },
                link: function (scope, element) { // NOSONAR

                    element.on('click', showDialog);

                    function saveData(dialogScope, form) {

                        form.submitted = true;

                        if (!form.valid) {
                            return;
                        }

                        dialogScope.$dismiss();

                        const savePromise = BaslerReferrerService.updateReferrer('quoteandbind', dialogScope.modelView.value);
                        $q.when(savePromise, () => {
                            scope.submission.referrer.value = dialogScope.modelView.value;
                        }, () => {
                            ModalService.showError(
                                'quoteandbind.directives.templates.basler.referrer-dialog.error.title',
                                'quoteandbind.directives.templates.basler.referrer-dialog.error.description');
                        });
                    }

                    function showDialog() {

                        //need a referrer copy in case customer decides to cancel changes
                        const referrerCopy = scope.submission.referrer.value ?
                            angular.copy(scope.submission.referrer.value) :
                            {
                                quoteID: scope.submission.quoteID.value,
                                sessionID: scope.submission.sessionUUID.value,
                            };

                        scope.data = { };
                        scope.data.modelView = ViewModelService.create(referrerCopy, 'pc',
                            'ch.baloise.gw.pc.edge.capabilities.quote.draft.dto.Referrer_ExtDTO');

                        ModalService.showSimpleDialog(dialogTemplate, scope.data, { saveData: saveData }, null);

                        element[0].focus();
                    }

                },
            };

        }; //directive

        directive.$inject = ['ModalService', 'BaslerReferrerService', '$q', '$translate', 'ViewModelService'];
        return directive;
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/directives/BaslerReferrer.js